// Mock数据文件

// 用户数据模板
export const defaultAboutInfoTemplate = {
  name: '未设置昵称',
  avatar: 'https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登录后完善您的个人信息！',
  email: '未设置邮箱',
  techStack: '暂无',
  interests: '暂无',
  github: '#',
  linkedin: '#',
  personalHomepage: '#',
};

// 初始用户数据
export const initialUsers = [
  {
    id: 1,
    username: 'admin',
    password: '123456',
    email: 'admin@example.com',
    name: '管理员',
    role: 'admin',
    avatar: '',
    avatarColor: '#1890ff',
    createdAt: '2023-01-01'
  },
  {
    id: 2,
    username: 'user',
    password: '123456',
    email: 'user@example.com',
    name: '普通用户',
    role: 'user',
    avatar: '',
    avatarColor: '#52c41a',
    createdAt: '2023-01-02'
  }
];

// 初始文章数据
export const initialPosts = [
  {
    id: '1766735622630',
    title: 'React Hooks 深度解析',
    author: 'admin',
    date: '2025-12-26 15:53:42',
    tags: ['React', 'JavaScript', '前端'],
    category: '前端',
    summary: '深入探讨React Hooks的原理和最佳实践，包括useState、useEffect、useContext等常用Hook的使用技巧。',
    content: `
# React Hooks 深度解析

## React简介
React是由Facebook开发的一个用于构建用户界面的JavaScript库。它以其组件化、声明式和高效的特性在前端开发领域广受欢迎。

## 为什么选择React？
React让构建交互式UI变得简单。通过组件化的开发模式，你可以轻松构建复杂的用户界面。

## 核心概念
- **组件(Components)**：React应用的基本构建块
- **JSX**：JavaScript的语法扩展，让你在JavaScript中编写类似HTML的代码
- **Props**：组件之间传递数据的方式
- **State**：组件内部的状态管理
- **Hooks**：让你在函数组件中使用状态和其他React特性

## useState Hook
useState是React中最基础的Hook，用于在函数组件中添加状态管理。

## useEffect Hook
useEffect用于处理副作用，如数据获取、订阅或手动修改DOM。

## 最佳实践
1. 只在最顶层使用Hook
2. 只在React函数中调用Hook
3. 使用自定义Hook复用逻辑

## 总结
React Hooks极大地简化了函数组件的状态管理和生命周期管理，是现代React开发的核心技术。`,
    readTime: '8分钟',
    views: 128,
    likes: 24,
    comments: 12
  },
  {
    id: '1766735622631',
    title: 'TypeScript 类型系统完全指南',
    author: 'admin',
    date: '2025-12-25 10:30:15',
    tags: ['TypeScript', '编程', 'Web开发'],
    category: 'TypeScript',
    summary: '全面介绍TypeScript的类型系统，从基础类型到高级类型工具，帮助你写出更安全的代码。',
    content: `
# TypeScript 类型系统完全指南

## 类型系统概述
TypeScript是JavaScript的超集，它添加了静态类型系统，让大型应用开发更加可靠。

## 基础类型
TypeScript支持JavaScript的所有基础类型，并新增了一些类型：
- number
- string
- boolean
- array
- tuple
- enum
- any
- void
- null 和 undefined
- never
- object

## 高级类型
### 联合类型
允许一个值可以是多种类型之一。

### 交叉类型
将多个类型合并为一个类型。

### 泛型
创建可重用的组件，一个组件可以支持多种类型的数据。

### 条件类型
根据条件选择不同的类型。

## 类型推断
TypeScript能够自动推断变量的类型。

## 类型断言
告诉TypeScript你知道更多的类型信息。

## 总结
TypeScript的类型系统提供了强大的工具来增强JavaScript代码的可靠性和可维护性。`,
    readTime: '12分钟',
    views: 96,
    likes: 18,
    comments: 8
  },
  {
    id: '1766735622632',
    title: 'CSS Grid 布局完全指南',
    author: 'user',
    date: '2025-12-24 14:20:30',
    tags: ['CSS', '布局', '前端'],
    category: '前端',
    summary: '深入理解CSS Grid布局，掌握网格系统的各种属性和用法，实现复杂的页面布局。',
    content: `
# CSS Grid 布局完全指南

## 什么是Grid布局？
CSS Grid布局是一个二维的布局系统，可以处理行和列。

## 基本概念
- **网格容器**：设置了display: grid的元素
- **网格项**：网格容器的直接子元素
- **网格线**：网格的划分线
- **网格轨道**：网格的行或列
- **网格单元格**：行和列交叉的区域
- **网格区域**：一个或多个网格单元格组成的矩形区域

## Grid容器属性
- display: grid
- grid-template-columns
- grid-template-rows
- grid-gap
- justify-items
- align-items

## Grid项属性
- grid-column
- grid-row
- grid-area
- justify-self
- align-self

## 响应式设计
结合媒体查询实现响应式网格布局。

## 总结
CSS Grid是现代CSS布局的强大工具，特别适合复杂的二维布局需求。`,
    readTime: '10分钟',
    views: 72,
    likes: 15,
    comments: 6
  }
];

// 初始评论数据
export const initialComments = [
  {
    id: 1,
    postId: '1766735622630',
    author: '张三',
    avatar: 'https://joeschmoe.io/api/v1/random',
    content: '这篇文章对我帮助很大，讲的非常详细！',
    datetime: '1天前',
    likes: 5
  },
  {
    id: 2,
    postId: '1766735622630',
    author: '李四',
    avatar: 'https://joeschmoe.io/api/v1/random',
    content: '感谢作者的分享，期待更多相关主题的文章！',
    datetime: '刚刚',
    likes: 2
  }
];

// 分类数据
export const categories = [
  { id: 1, name: '前端', count: 25 },
  { id: 2, name: '后端', count: 18 },
  { id: 3, name: 'JavaScript', count: 32 },
  { id: 4, name: 'React', count: 15 },
  { id: 5, name: 'Node.js', count: 12 },
  { id: 6, name: 'TypeScript', count: 8 },
  { id: 7, name: '其他', count: 10 }
];

// 标签数据
export const tags = [
  { id: 1, name: 'React', count: 15 },
  { id: 2, name: 'JavaScript', count: 32 },
  { id: 3, name: 'CSS', count: 20 },
  { id: 4, name: 'HTML', count: 18 },
  { id: 5, name: 'Node.js', count: 12 },
  { id: 6, name: 'TypeScript', count: 8 },
  { id: 7, name: '前端', count: 25 },
  { id: 8, name: '后端', count: 18 },
  { id: 9, name: '数据库', count: 10 },
  { id: 10, name: '算法', count: 15 }
];